import { ScenarioManager } from 'sonata-platform-components';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

import './contextSystem.scss';
import { CustomThemeProvider } from 'sonata-react-components';

type Props = {
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

export function ContextSystem({ user, userRoles }: Readonly<Props>) {
  return (
    <div className="contextSystem">
      <div className="contextSystem__content">
        <CustomThemeProvider themeContrast="dark">
          <ScenarioManager country={user.country} user={user} userRoles={userRoles} />
        </CustomThemeProvider>
      </div>
    </div>
  );
}
